import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import solid icons
import { 
  faHome,
  faUser,
  faCog,
  faSignOutAlt,
  faSignInAlt,
  faBars,
  faTimes,
  faRocket,
  faCubes,
  faBolt,
  faChartLine,
  faPuzzlePiece,
  faMobileAlt,
  faServer,
  faCode,
  faShieldAlt,
  faUsers,
  faBell,
  faComments,
  faBook,
  faStore,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTachometerAlt,
  faSpinner,
  faEdit,
  faTrash,
  faStar,
  faAnglesLeft,
  faAnglesRight,
  faQuestionCircle,
  faCreditCard,
  faDollarSign,
  faToggleOn,
  faToggleOff,
  faEye,
  faEyeSlash,
  faPowerOff,
  faPlay,
  faPause,
  faCheckCircle,
  faTimesCircle,
  faFile,
  faFileAlt,
  faFileInvoice,
  faTriangleExclamation,
  faDownload,
  faFilePdf,
  faSearch,
  faQuestion,
  faExclamation,
  faArrowLeft,
  faFileText,
  faExclamationTriangle,
  faXmark,
  faExternalLinkAlt,
  faRefresh,
  faPrint,
  faUpload,
  faCopy,
  faInfoCircle,
  faImages,
  faPlus,
  faMinus,
  faCirclePlus,
  faCloudUploadAlt,
  faFileImage,
  faMagicWandSparkles,
  faScissors,
  faExpandArrowsAlt,
  faCrop,
  faExclamationCircle,
  faBoxes,
  faLink,
  faSync,
  faFilter,
  faCodeBranch,
  faListUl,
  faCheck,
  faFileInvoiceDollar,
  faCartPlus,
  faCartShopping,
  faLock,
  faImage,
  faExpand,
  faCalculator,
} from '@fortawesome/free-solid-svg-icons'

// Import regular icons
import {
  faHeart,
  faBookmark,
  faCircle,
  faCircleDot
} from '@fortawesome/free-regular-svg-icons'

// Import brand icons
import {
  faGithub,
  faHubspot,
} from '@fortawesome/free-brands-svg-icons'

// Add icons to library
library.add(
  // Solid icons
  faHome,
  faUser,
  faCog,
  faSignOutAlt,
  faSignInAlt,
  faBars,
  faTimes,
  faRocket,
  faCubes,
  faBolt,
  faChartLine,
  faPuzzlePiece,
  faMobileAlt,
  faServer,
  faCode,
  faShieldAlt,
  faUsers,
  faBell,
  faComments,
  faBook,
  faStore,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTachometerAlt,
  faSpinner,
  faEdit,
  faTrash,
  faStar,
  faAnglesLeft,
  faAnglesRight,
  faQuestionCircle,
  faCreditCard,
  faDollarSign,
  faToggleOn,
  faToggleOff,
  faEye,
  faEyeSlash,
  faPowerOff,
  faPlay,
  faPause,
  faCheckCircle,
  faTimesCircle,
  faFile,
  faFileAlt,
  faFileInvoice,
  faTriangleExclamation,
  faDownload,
  faFilePdf,
  faSearch,
  faQuestion,
  faExclamation,
  faArrowLeft,
  faFileText,
  faExclamationTriangle,
  faXmark,
  faExternalLinkAlt,
  faRefresh,
  faPrint,
  faUpload,
  faCopy,
  faInfoCircle,
  faImages,
  faPlus,
  faMinus,
  faCirclePlus,
  faCloudUploadAlt,
  faFileImage,
  faMagicWandSparkles,
  faScissors,
  faExpandArrowsAlt,
  faCrop,
  faExclamationCircle,
  faBoxes,
  faLink,
  faSync,
  faFilter,
  faCodeBranch,
  faListUl,
  faCheck,
  faFileInvoiceDollar,
  faCartPlus,
  faCartShopping,
  faLock,
  faImage,
  faExpand,
  faCalculator,
  // Regular icons
  faHeart,
  faBookmark,
  faCircle,
  faCircleDot,
  // Brand icons
  faGithub,
  faHubspot,
)

// Make FontAwesome available globally
import { createApp } from 'vue'
const app = createApp({})
app.component('font-awesome-icon', FontAwesomeIcon)

export { FontAwesomeIcon }